import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=4e615b91&scoped=true&"
import script from "./not-found.ts?vue&type=script&lang=ts&"
export * from "./not-found.ts?vue&type=script&lang=ts&"
import style0 from "./not-found.scss?vue&type=style&index=0&id=4e615b91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e615b91",
  null
  
)

component.options.__file = "not-found.vue"
export default component.exports